import { render, staticRenderFns } from "./SocialHistory.vue?vue&type=template&id=58406cb5&scoped=true&"
import script from "./SocialHistory.vue?vue&type=script&lang=js&"
export * from "./SocialHistory.vue?vue&type=script&lang=js&"
import style0 from "./SocialHistory.vue?vue&type=style&index=0&id=58406cb5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58406cb5",
  null
  
)

export default component.exports